import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const AlertDialog = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
  confirmText = "OK",
  cancelText = "Cancel",
  severity = "info", // info, warning, error, success
  showCancel = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {showCancel && (
          <Button
            onClick={onClose}
            color="inherit"
          >
            {cancelText}
          </Button>
        )}
        <Button
          onClick={() => {
            if (onConfirm) onConfirm();
            onClose();
          }}
          variant="contained"
          color={
            severity === "error"
              ? "error"
              : severity === "warning"
              ? "warning"
              : severity === "success"
              ? "success"
              : "primary"
          }
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
